<div class="container-full content-wrapper">
    <div class="row">
        <div class="one-whole" style="margin-left:20px">
            <h3>{{'Add new mapping'|translate}}</h3>
            <div class="table">
                <table style="width: 100%">
                    <thead style="line-height:175%;">
                        <tr>
                            <th id="odysseyIdHeader">{{'Odyssey ID'|translate}}</th>
                            <th id="rdsmodelHeader">{{'RDS Model'|translate}}</th>
                            <th id="rdsmodelyearHeader">{{'RDS Model Year'|translate}}</th>
                            <th id="modelYearHeader">{{'Model Year'|translate}}</th>
                            <th id="vehicleLineCodeHeader">{{'Vehicle line code'|translate}}</th>
                            <th id="displayNameHeader">{{'Display name'|translate}}</th>
                            <th id="idsFeedbackNameHeader">{{'IDS Feedback name'|translate}}</th>
                            <th id="submit"></th>
                            <th id="reset"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><input class="rdsmappingtext" type="text" name="odysseyId" size="10" [(ngModel)]="odysseyId"></td>
                            <td><input class="rdsmappingtext" type="text" name="rdsModel" size="10" [(ngModel)]="rdsModel"></td>
                            <td><input class="rdsmappingtext" type="text" name="rdsModelYear" size="10" [(ngModel)]="rdsModelYear"></td>
                            <td><input class="rdsmappingtext" type="text" name="modelYear" size="10" [(ngModel)]="modelYear"></td>
                            <td><input class="rdsmappingtext" type="text" name="vehicleLineCode" size="10" [(ngModel)]="vlCode"></td>
                            <td><input class="rdsmappingtext" type="text" name="displayName" size="10" [(ngModel)]="displayName_1"></td>
                            <td><input class="rdsmappingtext" type="text" name="idsFeedbackName" size="10" [(ngModel)]="idsFeedbackName"></td>
                            <td><input class="rdsmappinginput" type="submit" name="Submit" value="{{'add'|translate}}" (click)="addSbdRdsdata()"
                                    id="sbdRdsModelMappingFormSubmit"></td>
                            <td><input class="rdsmappinginput" type="button" (click)="clearAllSbdRds()" value="{{'Clear'|translate}}"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="one-whole" style="margin-left:20px">
            <h3>{{'List of configured mappings'|translate}}</h3>
            <div class="table">
                <table style="width: 100%">
                    <thead>
                        <tr>
                            <th style="width: 10%;" id="odysseyIdListHeader">{{'Odyssey ID'|translate}}</th>
                            <th style="width: 10%;" id="rdsmodelListHeader">{{'RDS Model'|translate}}</th>
                            <th style="width: 10%;" id="rdsmodelyearListHeader">{{'RDS Model Year'|translate}}</th>
                            <th style="width: 10%;" id="modelYearListHeader">{{'Model Year'|translate}}</th>
                            <th style="width: 10%;" id="vehicleLineCodeListHeader">{{'Vehicle line code'|translate}}</th>
                            <th style="width: auto;" id="displayName1ListHeader">{{'Display name'|translate}}</th>
                            <th style="width: 10%;" id="idsFeedbackNameListHeader">{{'IDS Feedback name'|translate}}</th>
                            <th style="width: 10%;" id="update"></th>
                            <th style="width: 10%;" id="delete"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of sbdRdsList;">
                            <td>{{i.odysseyId}}</td>
                            <td><input class="rdsmappingtext" type="text" name="rdsModel" size="10" [(ngModel)]="i.rdsModel"></td>
                            <td><input class="rdsmappingtext" type="text" name="rdsModelYear" size="10" [(ngModel)]="i.rdsModelYear"></td>
                            <td><input class="rdsmappingtext" type="text" name="modelYear" size="10" [(ngModel)]="i.modelYear"></td>
                            <td><input class="rdsmappingtext" type="text" name="vehicleLineCode" size="10" [(ngModel)]="i.vlCode"></td>
                            <td><input class="rdsmappingtext" type="text" name="displayName_1" size="20" [(ngModel)]="i.displayName_1"></td>
                            <td><input class="rdsmappingtext"  type="text" name="idsFeedbackName" size="10" [(ngModel)]="i.idsFeedbackName">
                            </td>
                            <td><input class="rdsmappinginput" type="submit" name="Submit" value="{{'Update'|translate}}"
                                    (click)="updateSbdRdsdata(i.id,i.odysseyId,i.rdsModel,i.rdsModelYear,i.modelYear,i.vlCode,i.displayName_1,i.idsFeedbackName)"
                                    id="sbdRdsModelMappingUpdateSubmit"></td>
                            <td><input class="rdsmappinginput" type="submit" name="Submit" value="{{'Delete'|translate}}"
                                    (click)="deleteSbdRdsdata(i.id,i.odysseyId,i.rdsModel,i.rdsModelYear,i.modelYear,i.vlCode,i.displayName_1,i.idsFeedbackName)"
                                    id="sbdRdsModelMappingDeleteSubmit"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top" style="display: block;"
    (click)="topFunction()">